'use strict';

import {createApp} from 'vue/dist/vue.esm-bundler';
import store from "./plp_lp/store";
import PlpLPAppComponent from "./plp_lp/app.vue";
import PlpLPIntegratedAppComponent from "./plp_lp/appIntegrated.vue";
import PlpLPModalComponent from "./plp_lp/modal.vue";
import storePdp from "./plp_lp/storePdp";

const plplpApp = createApp({});
const plplpSmallApp = createApp({});
const plplpModal = createApp({})

// set filters for main apps
const mainApps = [plplpApp, plplpSmallApp];

mainApps.forEach(app => {
    app.config.globalProperties.$filters = {
        formatPriceFilter(value) {
            if (!value) {
                return '';
            }

            value = value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
            return value;
        }
    }
})

function scalapayWidgetShadowRootStyle() {
    const hostElements = document.querySelectorAll('.price-box .scalapay-widget scalapay-widget');
    const hostElementsSticky = document.querySelectorAll('.add-to-cart-bundle .scalapay-widget scalapay-widget');
    const styleContent = document.createElement('style');
    const styleLogo = document.createElement('style');

    styleContent.innerHTML = `
        .sp-pay-installment {
            justify-content: center;
        }`;

    styleLogo.innerHTML = `
        svg {
            width: 77px;
        }`;

    hostElements.forEach(hostElement => {
        if (hostElement.shadowRoot) {
            const host2Elements = hostElement.shadowRoot.querySelectorAll('scalapay-pay-installments');

            host2Elements.forEach(host2Element => {
                if (host2Element.shadowRoot)
                    host2Element.shadowRoot.appendChild(styleContent.cloneNode(true));
            });
        }
    });
    hostElementsSticky.forEach(hostElementSticky => {
        if (hostElementSticky.shadowRoot) {
            const host2ElementsSticky = hostElementSticky.shadowRoot.querySelectorAll('scalapay-pay-installments');

            host2ElementsSticky.forEach(host2ElementSticky => {
                const host3ElementsSticky = host2ElementSticky.shadowRoot.querySelectorAll('scalapay-logo');

                host3ElementsSticky.forEach(host3ElementSticky => {
                    if (host3ElementSticky.shadowRoot)
                        host3ElementSticky.shadowRoot.appendChild(styleLogo.cloneNode(true));
                });
            });
        }
    });
}

const scalaPayWidgetInterval = setInterval(() => {
    const scalaPayWidget = document.querySelector('.price-box .scalapay-widget scalapay-widget:not(#scalapay-widget-custom), .add-to-cart-bundle .scalapay-widget scalapay-widget:not(#scalapay-widget-custom)');

    if (scalaPayWidget && scalaPayWidget.shadowRoot && scalaPayWidget.shadowRoot.innerHTML.trim() !== '') {
        scalapayWidgetShadowRootStyle();
        clearInterval(scalaPayWidgetInterval);
    }
}, 100);

setTimeout(() => {
    clearInterval(scalaPayWidgetInterval);
}, 5000);

$(document).ready(function () {
    const plplpElement = $('#plp_lp');
    const plplpintegratedElement = $('#plp_lp_integrated');
    const plplpBigintegratedElement = $('#plp_lp_integrated-big');
    const plplpSmallintegratedElement = $('#plp_lp_integrated-small');
    const contactUsBtnPdp = $('.js-contact-us-pdp');

    if (plplpElement.length) {
        plplpApp
            .component('plp-lp', PlpLPAppComponent)
            .use(store);

        plplpApp.directive('click-outside', {
            mounted(el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    if (!(el === event.target || el.contains(event.target))) {
                        binding.value(event, el);
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unmounted(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
            }
        });

        plplpApp.mount('#plp_lp');

        plplpModal
            .component('plplp-modal', PlpLPModalComponent)
            .use(store)
            .mount('#plplp-modal');

    } else if (plplpintegratedElement.length) {
        plplpApp
            .component('plp-lp-integrated', PlpLPIntegratedAppComponent)
            .use(storePdp);

        plplpApp.mount('#plp_lp_integrated');

        plplpModal
            .component('plplp-modal', PlpLPModalComponent)
            .use(storePdp)
            .mount('#plplp-modal');
    } else if (plplpSmallintegratedElement.length) {
        plplpSmallApp
            .component('plp-lp-integrated', PlpLPIntegratedAppComponent)
            .use(storePdp);

        plplpSmallApp.mount('#plp_lp_integrated-small');

        plplpModal
            .component('plplp-modal', PlpLPModalComponent)
            .use(storePdp)
            .mount('#plplp-modal');

        if (plplpBigintegratedElement.length) {
            plplpApp
                .component('plp-lp-integrated', PlpLPIntegratedAppComponent)
                .use(storePdp);

            plplpApp.mount('#plp_lp_integrated-big');
        }
    }

    if (contactUsBtnPdp.length) {
        function saveUrl() {
            localStorage.setItem('URL', window.location.href);
        }

        contactUsBtnPdp.on('click', saveUrl);
        contactUsBtnPdp.on('auxclick', saveUrl);
    }
})
